import React from 'react'
import { compose, withState, lifecycle } from 'recompose'
import BluePrintRenderer from 'components/Canvas/renderer'
import { readOnData } from 'firebase/functions'
import { connect } from 'react-redux';
import { selectStoreId } from 'store/preferences/selectors'
import { Loader } from 'semantic-ui-react'
import withStoreTheme from 'store/theme/withStoreTheme'
import withTheme from 'hocs/bases/withTheme'
import inCartApi from 'apis/incartApis'
import { CMS_DEFAULT_IMAGE } from 'helpers/constants'

const mapStateToProps = (state) => ({
  storeId: selectStoreId(state)
});

const Demo = compose(
  withStoreTheme(),
  withTheme,
  connect(mapStateToProps),
  withState('bluePrint', 'setBluePrint', null),
  lifecycle({
    componentDidMount() {
      const { storeId, setBluePrint } = this.props
      readOnData(storeId, 'demo', (result) => setBluePrint(result))
    },
  })
)(
  ({
    bluePrint,
  }) => {
    if(!bluePrint){
      return <Loader active size="big">Loading...</Loader>
    }
    return (
      <BluePrintRenderer
        router={null}
        bluePrint={bluePrint}
        assets={{
          defaultImage: CMS_DEFAULT_IMAGE,
          attributeRule: [
            { code: 'hp_color', active: true },
          ]
        }}
        api={{
          fetchProductDetail: inCartApi.getProduct
        }}
      />
    )
  }
)

Demo.propTypes = {}
Demo.defaultProps = {}

export default Demo



// WEBPACK FOOTER //
// ./src/pages/Demo/index.js